<template>
  <div v-if="locationDetail">
    <div class="qtm-label" v-text="locationDetail.name" />
    <qtm-address v-bind="locationDetail" :postal-code="locationDetail.postal_code" />
  </div>
</template>

<script setup lang="ts">
import type { Jobsite, Location } from '@quotetome/materials-api'

export interface Props {
  jobsite?: Jobsite
  location?: number | null
}

const props = defineProps<Props>()

const locations = ref<Location[]>([])
const locationDetail = computed(() => {
  if (props.location) {
    return locations.value.find(location => location.id === props.location)
  }

  return null
})

const { $api, $error } = useNuxtApp()

onMounted(async () => {
  if (!props.location) {
    return
  }

  if (props.jobsite?.locations.some(location => location.id === props.location)) {
    locations.value = props.jobsite.locations
    return
  }

  try {
    locations.value = await $api.v1.locations.list({ id: props.location }).then(response => response.data)
  }
  catch(error) {
    $error.report(error)
  }
})
</script>
